import { string, boolean, object, mixed,number } from "yup";

export const SoucheSchema = object({
    type: string().required('type obligatoire !'),
    souche:number().required('number obligatoire !'),
    seq: string().required('type obligatoire !'),
});